import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Alert } from 'react-bootstrap'
import FormContainer from '../components/FormContainer.js'
import Loader from '../components/Loader.js'
import { API_URL } from '../apiUrl.js'

const VerifyOwnerEmailScreen = () => {
  const [status, setStatus] = useState({ loading: true, message: '' })

  useEffect(() => {
    const token = window.location.hash.slice(1)
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}${window.location.search}`
    )

    if (!token) {
      setStatus({
        loading: false,
        message: 'This verification link is invalid or has expired.'
      })
      return
    }

    let active = true
    axios
      .post(`${API_URL}/owners/verify-email`, { token })
      .then(({ data }) => {
        if (active) {
          setStatus({ loading: false, message: data.message, success: true })
        }
      })
      .catch((error) => {
        if (active) {
          setStatus({
            loading: false,
            message:
              error.response?.data?.message ||
              'Email verification failed. Please request a new link.'
          })
        }
      })

    return () => {
      active = false
    }
  }, [])

  return (
    <FormContainer>
      <h1>Verify email</h1>
      {status.loading ?
        <Loader />
      : <Alert variant={status.success ? 'success' : 'danger'}>
          {status.message}
        </Alert>
      }
      {!status.loading && (
        <Link to='/owner/login' className='btn btn-outline-primary'>
          Continue to owner sign in
        </Link>
      )}
    </FormContainer>
  )
}

export default VerifyOwnerEmailScreen
